module.exports = __webpack_public_path__ + "static/media/acc.11af97bc.png";